
import FormInput2 from '@/components/forms/FormInput2.vue'
import { Component, Vue } from 'vue-property-decorator'
import DatePicker from '@/components/elements/DatePicker.vue'
import moment, { Moment } from 'moment-timezone'
import { openModal } from '@/helpers/Modals'

interface DatePickerAnnotation {
  date: Moment
  style: MessageStyle
  message: string
}

@Component({
  components: { FormInput2 },
})
export default class DialogWrapperStory extends Vue {
  selected: Moment | null = this.today.clone()

  mounted() {
    openModal({
      name: 'date-picker-modal',
      title: 'Choose date',
      component: DatePicker,
      props: {
        id: 'date-picker-modal',
        minDate: this.today.clone().subtract('3', 'month'),
        selected: this.selected,
        onSelect: (v: Moment) => (this.selected = v),
        getDateStatus: this.getDateStatus,
        getDateAnnotations: this.getDateAnnotations,
      },
      size: 'lg',
      closeable: true,
    })
  }

  get today() {
    // Have a fixed date as for that so visual regression tests
    return moment('2022/10/05')
  }

  get annotations(): DatePickerAnnotation[] {
    const tomorrow = this.today.clone().add(1, 'day')
    const nextWeek = this.today.clone().add(1, 'week').add(3, 'day')

    return [
      {
        message: 'Peak hour',
        style: 'warning',
        date: tomorrow,
      },
      {
        message: 'Artist on-site',
        style: 'info',
        date: tomorrow,
      },
      {
        message: 'Half-price children',
        style: 'promo',
        date: tomorrow,
      },
      {
        message: 'Construction',
        style: 'warning',
        date: nextWeek,
      },
    ]
  }

  getDateAnnotations(date: Moment): MessageAction[] {
    return this.annotations
      .filter((item) => date.isSame(item.date, 'day'))
      .map((item) => ({ message: item.message, style: item.style }))
  }

  getDateStatus(date: Moment): DateAvailabilityStatus {
    const next3Day = this.today.clone().add(3, 'day')
    if (date.isSame(next3Day, 'day')) {
      return 'sold_out'
    } else {
      return 'available'
    }
  }
}
